import React from "react";
import {Box, Grid, Typography} from "@mui/material";
import SwitchComponent from "../../../components/switch/switch";

import "./notifications.css";
import {useNotificationSettings, useUpdateProfileData} from "../../../graphql/graphql/profile/hooks";
import {toast} from "react-toastify";
import LoadingWall from "../../../components/loadingWall";

const notifyDetail = [
  {
    title: "Enable Payment Receipts",
    detail: "Receive an email every time your payment is processed.",
    name: "emailReceipts",
  },
  {
    title: "Enable Referral Alerts",
    detail: "Receive an email every time someone uses your link to sign up.",
    name: "referralAlerts",
  },
  {
    title: "Newsletter",
    detail: "Receive emails with our daily or weekly newsletter.",
    name: "newsletter",
  },
];

const Notifications = () => {
  const {data, loading: inLoading} = useNotificationSettings();
  const {updateNotificationSettings, loading} = useUpdateProfileData();
  if (!data) return <LoadingWall />;
  return (
    <Box className="notificationMain">
      <Typography variant="h4" className="setting_page_heading">
        Notifications
      </Typography>
      <Box className="content">
        {notifyDetail.map((notify, key) => (
          <Box className="notifyDetails" key={key}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h5">{notify.title}</Typography>
              <SwitchComponent
                loading={loading}
                handleChange={(e) => {
                  updateNotificationSettings({
                    [notify.name]: e.target.checked,
                  })
                    .then(() => {
                      toast.success("Notification settings updated successfully");
                    })
                    .catch((err) => {
                      toast.error("Something went wrong, please try again later");
                    });
                }}
                checked={data[notify.name]}
              />
            </Box>
            <Typography variant="h6">{notify.detail}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Notifications;
